"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGridDetails = void 0;
var react_1 = __importStar(require("react"));
var validation_1 = require("../validation");
var buttons_1 = require("../buttons");
var blockers_1 = require("../blockers");
var FormGridDetailsInternal = function (props, ref) {
    var _a = (0, validation_1.useValidatedState)(function () {
        if (props.ctx.row) {
            return __assign(__assign({}, props.ctx.row), { invalid: false });
        }
        else {
            return props.initial();
        }
    }, props.ctx.schema), model = _a[0], setModel = _a[1], errors = _a[2], validate = _a[3];
    var containerId = 'form-grid-details';
    var containerSelector = "#".concat(containerId);
    (0, react_1.useImperativeHandle)(ref, function () { return ({
        getUncommited: function (revalidate) { return __awaiter(void 0, void 0, void 0, function () {
            var isValid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!revalidate) return [3, 2];
                        return [4, validate(containerSelector)];
                    case 1:
                        isValid = _a.sent();
                        return [3, 3];
                    case 2:
                        isValid = props.ctx.row ? !props.ctx.invalid : true;
                        _a.label = 3;
                    case 3: return [2, [props.ctx.row, model, !isValid]];
                }
            });
        }); },
    }); });
    (0, react_1.useEffect)(function () {
        if (props.ctx.row && props.ctx.invalid) {
            validate(containerSelector);
        }
    }, []);
    (0, blockers_1.useCommittedState)(model);
    var detailsCtx = {
        readOnly: props.ctx.readOnly,
        model: model,
        setModel: setModel,
        errors: errors,
        validate: validate,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { id: containerId }, props.children ? props.children(detailsCtx) : react_1.default.createElement(react_1.default.Fragment, null)),
        !props.ctx.readOnly && (react_1.default.createElement("div", { className: "row mt-4" },
            react_1.default.createElement("div", { className: "col" },
                react_1.default.createElement(buttons_1.Button, { id: "add-or-update-grid-".concat(props.id), label: props.ctx.row ? 'Update' : 'Add', onClick: function () { return validate(containerSelector).then(function (v) { return v && props.ctx.onChange(props.ctx.row, model); }); } }),
                react_1.default.createElement(buttons_1.Button, { id: "cancel-grid-".concat(props.id), className: "ml-4", label: 'Cancel', onClick: function () { return props.ctx.onChange(props.ctx.row, props.ctx.row); } }))))));
};
var FormGridDetailsWithRef = (0, react_1.forwardRef)(FormGridDetailsInternal);
var FormGridDetails = function (props) {
    return react_1.default.createElement(FormGridDetailsWithRef, __assign({}, props, { ref: props.ctx.detailsRef }));
};
exports.FormGridDetails = FormGridDetails;
//# sourceMappingURL=FormGridDetails.js.map